export const PROXIMITY_UNAVAILABLE = {
  road: 'Main road check unavailable. Check local roads before relying on this result.',
  train: 'Train station check unavailable. Check station locations before relying on this result.',
};

export function formatProximityResult(data, kind) {
  const unknown = { status: 'Unknown', distance: null, details: PROXIMITY_UNAVAILABLE[kind] };
  if (!data || typeof data !== 'object' || Array.isArray(data) || data.error || data.success === false) return unknown;
  const status = String(data.status || '').trim().toLowerCase();
  const failed = ['message', 'details', 'note'].some(key => /error|timeout|timed out|unavailable|not available|undetermined|failed|could not determine|unable to determine/i.test(String(data[key] || '')));
  if (failed || (status && !['detected', 'not detected'].includes(status))) return unknown;
  const flag = kind === 'road' ? 'near_highway' : 'near_train_line';
  let detected = data[flag];
  if (detected !== undefined && typeof detected !== 'boolean') return unknown;
  if (typeof detected === 'boolean') {
    if (status && (status === 'detected') !== detected) return unknown;
  } else if (status) detected = status === 'detected';
  else return unknown;
  return {
    ...data, status: detected ? 'Detected' : 'Not Detected',
    distance: Number.isFinite(data.distance_meters) ? `${Math.round(data.distance_meters)}m` : null,
    road_name: typeof data.road_name === 'string' ? data.road_name : null,
    road_type: typeof data.road_type === 'string' ? data.road_type : null,
    nearest_station: typeof data.nearest_station === 'string' ? data.nearest_station : null,
  };
}
